import { GUTTER } from '../configs/consts'
import styled from '@emotion/styled'

const Popup = (props) => {

  const closePopup = () => {
    props.control.setIsOpen(false);
  }

  if(props.control.isOpen) {
    document.body.style.overflow = "hidden"
  }
  else{
    document.body.style.overflow = "initial"
  }

  return <StyledPopup {...props} gutter={GUTTER}>
    <div className={'outside'} onClick={closePopup} />
    <div className={'window'}>
      <div className={'close-button'} onClick={closePopup}>
        &times;
      </div>
      <div className={'content-area'}>
        {props.control.content}
      </div>
    </div>
  </StyledPopup>
}



const StyledPopup = styled.div`
  display: ${props => props.control.isOpen ? 'flex' : 'none'};
  position: fixed;
  background: rgba(255,255,255,0.5);
  top:0;
  left:0;
  width:100vw;
  height:100vh;
  z-index:99990;
  align-items:center;
  align-content:center;

  .outside {
    position: fixed;
    top: 0; 
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1;
  }

  .window{
    position: relative;
    overflow: hidden;
    background: white;
    margin: auto;
    border-radius:5px;
    z-index:2;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

    .close-button{
      position: absolute;
      top: 5px;
      right: 5px;
      width: 1em;
      height: 1em;
      text-align: center;
      line-height: 1em;
      border-radius: 1em;
      background-color: white;
      font-size: 30px;
      color: ${props => props.control?.themeLayout?.link || '#767676'};
      cursor: pointer;
      user-select: none;
    }

    .content-area{
      max-width: ${props => `calc(100vw - ${props.gutter * 2}px)`};
      max-height: ${props => `calc(100vh - ${props.gutter * 2}px)`};
      overflow: auto;
    }
  }
`

export default Popup;